import React from 'react';
import printerIcon from "../../../assets/images/mydevices/printIcon.svg";
import './ChooseDeviceBelow.css';
import BlockHeader from './BlockHeader/BlockHeader';
import { useTranslation } from 'react-i18next';

const ChooseDeviceBelow = () => {
   const { t } = useTranslation(["translation"]);
  return (
    <div className="my-device-choose-my-device-wrapper">
      <div className='desktop-view'>
        <BlockHeader 
          icon={printerIcon}
          iconTitle= "printer-icon"
          iconAlt= "printer-icon"
          title= {t("MY_DEVICES.CHOOSE_DEVICE.BELOW_TEXT")}
        />
      </div>
      <div className='mobile-view'>
        <div className='content-wrapper'>
          <div className='title-wrapper'>
            <span>{t("MY_DEVICES.CHOOSE_DEVICE.SELECT_DEVICE")}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseDeviceBelow;